import { render, staticRenderFns } from "./VoucherTable.vue?vue&type=template&id=8c0f06ec"
import script from "./VoucherTable.vue?vue&type=script&lang=js"
export * from "./VoucherTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports